module.exports = __webpack_public_path__ + "static/media/glass.3346aed1.svg";